<template>
  <div class="integral-class" v-loading="loading">
    <div class="bg-img"></div>
    <div class="card">
      <div class="head">
        <span>我的账户({{token}})</span>
        <span style="float: right">可用积分统计截止2021年1月21日</span>
      </div>
      <div class="flex">
        <div>
          <div>{{integral.accumulative || 0}}</div>
          <div>累计积分</div>
        </div>
        <div>
          <div>{{integral.usable || 0}}</div>
          <div>可用积分</div>
        </div>
        <div>
          <div>{{integral.conversion || 0}}</div>
          <div>已兑换积分</div>
        </div>
      </div>
    </div>
    <div class="content">
      <el-tabs v-model="activeName">
        <el-tab-pane label="兑换礼品" name="first">
          <div class="overflow-body">
            <Integral @exchange="exchange" :usable="integral.usable" />
          </div>
        </el-tab-pane>
        <el-tab-pane label="兑换记录" name="second">
          <div class="overflow-body">
            <Record ref="record"/>
          </div>
        </el-tab-pane>
        <el-tab-pane label="兑换规则说明" name="third">
          <div class="third-class">
            一、
            用户使用EICAD软件所产生的积分，所有权归江苏狄诺尼所有。用户对个人使用软件产生的积分不享有分配、转移、提现、过户等权益。积分兑换的商品我司不提供任何报销单据，由此产生的个人税费等法律问题由用户承担。
            <br />二、
            我司有权对参加积分兑换活动的用户进行资格复核，如有违规操作行为或不满足活动要求的用户，我司有权在不通知用户的情况下，取消其兑换资格，并对已经兑换的积分清零；
            <br />三、
            本次活动已兑换积分、未使用积分及未参加此次活动的用户个人积分，我司有权做扣除、清零及不累计参加后续积分活动的处理；
            <br />四、 我司对用户参加的积分兑换活动，享有包括但不限于推广、宣传、刊登、展示、画册制作等权利。
            <br />五、 本次活动最终解释权归江苏狄诺尼信息技术有限责任公司所有。
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import { API__code, API_Integral } from '../../api/index.js'
import Record from "./record";
import Integral from "./exchange";
export default {
  data() {
    return {
      activeName: "first",
      integral:{},
      token:'',
      checkCode:'',
      loading:false
    };
  },
  created(){
    this.getCookie();
    this.getUserIntegral();
  },
  methods:{
    exchange(type){//兑换成功后刷新剩余积分与兑换记录
      if(type == 1){
        this.getUserIntegral();
        this.$refs.record.tbCreditsExchangeGetList();
      }else if(type == 2){//点击申请兑换时
        this.loading = true;
      }else if(type == 3){//请求成功时
        this.loading = false;
      }
    },
    getUserIntegral(){
      this.loading = true;
      var param = {
        token:this.token,
        checkCode:this.checkCode,
        userId:sessionStorage.getItem('dnnypt_id')
      }
      API_Integral.getUserIntegral(param)
				.then((res)=>{
          if(res.data.code == API__code.SUCCESS){
            this.integral = res.data.data;
            this.loading = false;
          }
        })
    },
		//读取cookie
		getCookie: function() {
		  if (document.cookie.length > 0) {
				var arr = document.cookie.split('; ');
				for (var i = 0; i < arr.length; i++) {
						var arr2 = arr[i].split('=');
						if (arr2[0] == 'dnnypt_token') {
								this.token = arr2[1];
						} else if (arr2[0] == 'dnnypt_checkCode') {
								this.checkCode = arr2[1];
						}
				}
			}
	  }
  },
  components: {
    Record,
    Integral,
  },
};
</script>
<style lang="scss">
.el-tabs__nav-scroll {
  padding-top: 10px;
}

.el-tabs__item {
  font-size: 13px;
}
.el-tabs__item:hover {
  font-size: 13px;
}

.el-tabs__item.is-active {
  font-size: 14px;
}

.el-tabs__nav-wrap::after {
  content: "";
  background-color: #fff2ee;
}
</style>
<style lang="scss" scoped>
.integral-class {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: auto;
  background: url("../img/integral.png") no-repeat;
  background-size: 100% 100%;
}

.bg-img{
  position: relative;
  width: 900px;
  background: url("../img/banner.png") no-repeat;
  height: 400px;
  margin: auto;
}

.card {
  position: relative;
  margin: auto;
  width: 25%;
  min-width: 453px;
  min-height: 155px;
  height: calc(16%);
  margin-top: -175px;
  //margin-left: 100px;
  left: -70px;
  // background: linear-gradient(180deg, #fed15d 0%, #e3ab1a 100%);
  background: url("../img/image-wen.png") no-repeat;
  border-radius: 7px;

  padding: 15px 10px 15px 20px;
  box-sizing: border-box;

  .flex {
    width: 100%;
    display: flex;
    margin-top:10px;
    div {
      flex: 0 0 32%;
      div:nth-child(1) {
        font-weight: 900;
        font-size: 24px;
        line-height: 35px;
        color: #693d25;
      }
      div:nth-child(2) {
        font-size: 14px;
        line-height: 22px;
        color: #9c5d3a;
      }
    }
  }

  .head {
    span:nth-child(1) {
      font-family: Noto Sans SC;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 20px;

      color: #693d25;
    }

    span:nth-child(2) {
      font-family: Noto Sans SC;
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 20px;
      /* identical to box height, or 167% */

      text-align: right;

      color: #9c5d3a;
    }
  }
}

.content {
  position: relative;
  margin: auto;
  width: 30%;
  min-width: 780px;
  height:  calc(100vh - 349px);
  background: #fff2ee;
  //border-radius: 13px;
  border-top-left-radius: 13px;
  border-top-right-radius: 13px;
  z-index: 2000;
  margin-top: -31px;
  left: 20px;
  //overflow: auto;
  box-sizing: border-box;
  padding: 0px 20px;
}

.overflow-body{
  height:  calc(100vh - 415px);
  overflow: auto;
}

.third-class {
  line-height: 30px;
  font-family: Noto Sans SC;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  color: #666666;
}
</style>

<style lang="scss" scoped>
@media only screen and (max-width: 1360px) {
  .third-class {
    font-size: 13px;
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?606bc8ba